import { TextField } from "@material-ui/core";
import React, { useEffect } from "react";

export interface RegexTextFieldProps {
  label: React.ReactNode;
  onChange?: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onChangeIsValid?: (isEmailValid: boolean) => void;
  value: string;
  required?: boolean;
  error?: boolean;
  disabled?: boolean;
  placeholder?: string;
  variant?: "standard" | "filled" | "outlined" | undefined;
}

const RegexTextField: React.FC<RegexTextFieldProps & { validationRegex: RegExp }> = ({
  label,
  onChange,
  onChangeIsValid,
  required,
  value,
  validationRegex,
  error,
  disabled,
  placeholder,
  variant,
}) => {
  const isValid = value.length < 1 ? !required : validationRegex.test(value);

  useEffect(() => {
    onChangeIsValid!(isValid);
  }, [isValid, onChangeIsValid]);

  return (
    <TextField
      label={label}
      error={!isValid}
      fullWidth={true}
      onChange={onChange}
      value={value}
      required={required}
      disabled={disabled}
      placeholder={placeholder}
      variant={variant}
    />
  );
};

RegexTextField.defaultProps = {
  onChangeIsValid: () => {},
  required: false,
} as Partial<RegexTextFieldProps>;

export default RegexTextField;
